import React, { Fragment } from 'react';
import { Uploading } from '../../Uploading/Uploading';
import { UploadSuccess } from '../../UploadSuccess/UploadSuccess';
import { UploadFail } from '../../UploadFail/UploadFail';
export var UploadStatusModal = function UploadStatusModal(props) {
  var statusType = props.statusType,
    onClose = props.onClose,
    _props$previewUrl = props.previewUrl,
    previewUrl = _props$previewUrl === void 0 ? '' : _props$previewUrl,
    _props$avatarStyle = props.avatarStyle,
    avatarStyle = _props$avatarStyle === void 0 ? {} : _props$avatarStyle;
  var uploadingModal = React.createElement(Uploading, {
    previewUrl: previewUrl,
    avatarStyle: avatarStyle,
    show: true,
    desc: '图片上传中，请稍后...',
    onClose: onClose,
    progressColor: '#3AC25C'
  });
  var uploadSuccessModal = React.createElement(UploadSuccess, {
    previewUrl: previewUrl,
    avatarStyle: avatarStyle,
    onClose: onClose,
    show: true,
    onOk: onClose
  });
  var uploadFailModal = React.createElement(UploadFail, {
    onClose: onClose,
    previewUrl: previewUrl,
    avatarStyle: avatarStyle,
    show: true,
    desc: '上传图片失败，请重新上传',
    onRetry: onClose
  });
  var content;
  switch (statusType) {
    case 'uploading':
      {
        content = uploadingModal;
        break;
      }
    case 'success':
      {
        content = uploadSuccessModal;
        break;
      }
    case 'partialSuccess':
      {
        content = React.createElement(UploadFail, {
          onClose: onClose,
          previewUrl: previewUrl,
          avatarStyle: avatarStyle,
          show: true,
          desc: '部分图片上传失败，请重新上传',
          onRetry: onClose
        });
        break;
      }
    case 'failed':
      {
        content = uploadFailModal;
        break;
      }
    default:
      {
        content = React.createElement(Fragment, null);
      }
  }
  return content;
};